// extracted by mini-css-extract-plugin
export var btnConfirm = "Button__btnConfirm-YyYbe";
export var btnFormal = "Button__btnFormal-cuwsE";
export var btnIcon = "Button__btnIcon-OokN6";
export var btnMinimum = "Button__btnMinimum-hdWab";
export var btnOutline = "Button__btnOutline-n-xui";
export var btnPrimary = "Button__btnPrimary-bCoU7";
export var btnSecondary = "Button__btnSecondary-whaqs";
export var btnSlim = "Button__btnSlim-uI8lv";
export var btnText = "Button__btnText-wSeX-";
export var btnWarning = "Button__btnWarning-y1cVj";
export var isActived = "Button__is-actived-T0cXS";